import ListEquipmentTable from "./ListEquipmentTable";

export default ListEquipmentTable;
